import React from "react";
import "../App.css";

export const Privacy = () => {
  React.useEffect(() => {}, []);

  return (
    <div className="privacy-policy">
      <div className="GAP-H100" />

      <div className="limiter2">
        <a href="/" style={{ textDecoration: "none", color: "#4a41ff" }}>
          {"← Voltar p/ Site"}
        </a>
        <div className="GAP-H20" />

        <h1>Política de Privacidade</h1>

        <p>
          Na Morfos, respeitamos sua privacidade e estamos comprometidos em
          proteger seus dados pessoais. As informações coletadas neste
          formulário serão utilizadas exclusivamente para entender suas
          necessidades de desenvolvimento de aplicativos e entrar em contato com
          você.
        </p>
        <p>
          Não compartilhamos suas informações com terceiros sem seu
          consentimento. Ao prosseguir, você concorda com esta política e com o
          uso de seus dados conforme descrito.
        </p>
      </div>
    </div>
  );
};
